import { FormlyFieldConfig } from 'ng-formly';
export const pagelayoutFields: Array<FormlyFieldConfig> = [
    {
        key: 'name',
        type: 'input-field',
        className: "col-md-4",
        templateOptions: {
            type: 'text',
            placeholder: 'Unique name for the page layout',
            required: true,
            label: 'Name'
        }
    },
    {
        key: 'label',
        type: 'input-field',
        className: "col-md-4",
        templateOptions: {
            type: 'text',
            placeholder: 'Label for the page layout',
            required: true,
            label: 'Label'
        }
    },
    {
        key: 'tabsetup',
        type: 'select-component',
        className: "col-md-4",
        defaultValue: 'single',
        templateOptions: {
            options: [
                {
                    label: 'Single Page',
                    value: 'single'
                },
                {
                    label: 'Multiple Tab Pages',
                    value: 'tabs'
                },
                {
                    label: 'Multi Page Wizard',
                    value: 'wizard'
                }
            ],
            label: 'Tab Page Setup',
            required: false
        }
    },
    {
        key: 'description',
        type: 'textarea-field',
        templateOptions: {
            placeholder: 'Description for the page layout',
            required: true,
            label: 'Description'
        }
    },
    {
        key: 'template',
        type: 'textarea-field',
        hideExpression: 'model.tabsetup !== "single"',
        templateOptions: {
            type: 'html',
            placeholder: 'Template for the page layout',
            required: true,
            label: 'HTML Template (Please Minify the HTML before Pasting here)',
            'rows': 15
        }
    },
    {
        type: 'repeatedsection',
        key: 'tabs',
        className: 'row',
        fieldArray: {
            templateOptions: {
                btnText: 'Add Tab Page',
                label: 'Tabs'
            },
            fieldGroup: [
                {
                    type: 'input-field',
                    key: 'key',
                    className: 'col-md-4',
                    templateOptions: {
                        type: 'text',
                        label: 'Key for Tab',
                        required: true,
                    },
                },
                {
                    key: 'tabpage',
                    type: 'select-component',
                    className: 'col-md-6',
                    templateOptions: {
                        type: 'entitypagelayout',
                        label: 'Tab Page Layout',
                        required: true
                    }
                },
                {
                    key: 'refreshonclick',
                    type: 'checkbox',
                    className: 'col-md-2',
                    defaultValue: false,
                    templateOptions: {
                        required: true,
                        label: 'Refresh on Click'
                    }
                }
            ]
        }
    },
    {
        type: 'repeatedsection',
        key: 'dataelements',
        className: 'row',
        fieldArray: {
            templateOptions: {
                btnText: 'Add Data Element',
                label: 'Data Elements'
            },
            fieldGroup: [
                {
                    type: 'input-field',
                    key: 'key',
                    className: 'col-md-3',
                    templateOptions: {
                        type: 'text',
                        label: 'Key for Dataelement Data',
                        required: true,
                    },
                },
                {
                    key: 'dataelement',
                    type: 'select-component',
                    className: 'col-md-6',
                    templateOptions: {
                        type: 'dataelement',
                        label: 'DataElement',
                        required: true
                    }
                },
                {
                    key: 'collection',
                    type: 'select-component',
                    className: 'col-md-3',
                    templateOptions: {
                        options:
                        [{
                            label: 'Entity Record',
                            value: 'entityrecord'
                        },
                        {
                            label: 'Aggregates',
                            value: 'aggregates'
                        },
                        {
                            label: 'Activities',
                            value: 'activity'
                        },
                        {
                            label: 'Time Series',
                            value: 'timeseries'
                        }],
                        label: 'Collection (if Override Needed)',
                        required: false
                    }
                }
                // {
                //     key: 'processonlayoutinit',
                //     type: 'checkbox',
                //     className: 'col-md-2',
                //     defaultValue: false,
                //     templateOptions: {
                //         required: true,
                //         label: 'Process on Initiation'
                //     }
                // }
            ]
        }
    },
    {
        type: 'repeatedsection',
        key: 'forms',
        className: 'row',
        fieldArray: {
            templateOptions: {
                btnText: 'Add Form',
                label: 'Forms - Use %formname to refer'
            },
            fieldGroup: [
                {
                    type: 'input-field',
                    key: 'name',
                    className: 'col-md-4',
                    templateOptions: {
                        type: 'text',
                        label: 'Form Name',
                        required: true,
                    },
                },
                {
                    key: 'hidegobutton',
                    type: 'checkbox',
                    className: 'col-md-2',
                    defaultValue: false,
                    templateOptions: {
                        required: false,
                        label: 'Hide Go Button'
                    }
                },
                {
                    key: 'fields',
                    type: 'textarea-field',
                    className: 'col-md-12',
                    templateOptions: {
                        label: 'Form Fields JSON',
                        required: true,
                        description: 'Form Fields (Please Minify the JSON before Pasting here)',
                        rows: 5
                    }
                }
            ]
        }
    },
    {
        type: 'repeatedsection',
        key: 'settings',
        className: 'row',
        fieldArray: {
            templateOptions: {
                btnText: 'Add Settings',
                label: 'Settings - Use %settingname to refer'
            },
            fieldGroup: [
                {
                    type: 'input-field',
                    key: 'name',
                    className: 'col-md-2',
                    templateOptions: {
                        type: 'text',
                        label: 'Setting Name',
                        required: true
                    }
                },
                {
                    key: 'settingEntity',
                    type: 'select-component',
                    className: 'col-md-4',
                    templateOptions: {
                        type: 'entity',
                        label: 'Entity',
                        options: [],
                        multiple: false,
                        required: true,
                        placeholder: ''
                    }
                },
                {
                    key: 'settingFields',
                    type: 'select-component',
                    className: 'col-md-6',
                    templateOptions: {
                        type: 'entityfield',
                        parent: 'settingEntity',
                        label: 'Fields',
                        options: [],
                        multiple: true,
                        required: true,
                        placeholder: ''
                    }
                },
            ]
        }
    },
    {
        type: 'repeatedsection',
        key: 'charts',
        className: 'row',
        fieldArray: {
            templateOptions: {
                btnText: 'Add Chart',
                label: 'Charts'
            },
            fieldGroup: [
                {
                    type: 'input-field',
                    key: 'name',
                    className: 'col-md-3',
                    templateOptions: {
                        type: 'text',
                        label: 'Chart Name',
                        required: true
                    },
                },
                {
                    type: 'input-field',
                    key: 'label',
                    className: 'col-md-3',
                    templateOptions: {
                        type: 'text',
                        label: 'Chart Label',
                        required: true
                    }
                },
                {
                    key: 'chart',
                    type: 'select-component',
                    className: 'col-md-2',
                    templateOptions: {
                        type: 'chart',
                        label: 'Chart',
                        required: true
                    }
                },
                {
                    key: 'height',
                    type: 'input-field',
                    className: 'col-md-2',
                    templateOptions: {
                        type: 'text',
                        label: 'Height (px)'
                    }
                },
                {
                    key: 'width',
                    type: 'input-field',
                    className: 'col-md-2',
                    templateOptions: {
                        type: 'text',
                        label: 'Width (%)'
                    }
                },
                {
                    key: 'options',
                    type: 'textarea-field',
                    className: 'col-md-12',
                    templateOptions: {
                        label: 'Chart Options (Please Minify the JSON before Pasting here)',
                        'rows': 5
                    }
                }
            ]
        }
    }
];


// WEBPACK FOOTER //
// ./src/app/shared/formfields/pagelayout.ts